/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryTimExecutionReportResult
 */
export interface PalSubmissionListEntryTimExecutionReportResult {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryTimExecutionReportResult
     */
    level?: string;
}

/**
 * Check if a given object implements the PalSubmissionListEntryTimExecutionReportResult interface.
 */
export function instanceOfPalSubmissionListEntryTimExecutionReportResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalSubmissionListEntryTimExecutionReportResultFromJSON(json: any): PalSubmissionListEntryTimExecutionReportResult {
    return PalSubmissionListEntryTimExecutionReportResultFromJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionReportResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryTimExecutionReportResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'level': !exists(json, 'level') ? undefined : json['level'],
    };
}

export function PalSubmissionListEntryTimExecutionReportResultToJSON(value?: PalSubmissionListEntryTimExecutionReportResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'level': value.level,
    };
}

